import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-d',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-d.component.html',
  styleUrl: './section-d.component.css'
})
export class SectionDComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection6 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionDForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "How organized is the student's thinking and behavior in general? Please explain: *",
      formControlName: "general_behavior_organization",
    },
    {
      question: "How organized is the student's thinking and behavior as it relates to this specific situation? Please explain: *",
      formControlName: "specific_behavior_organization",
    }
  ]

  radioQuestions = [
    {
      id: 'means_for_attack',
      questionText: 'Does the student have the means (access to weapons or dangerous materials) to carry out an attack? *',
      formControlName: 'means_for_attack',
      infoFormControlName: 'means_for_attack_explanation',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.fullTeamAssessmentData?.[question.formControlName] || '', Validators.required);
    });
    group['d_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.d_additional_info) || this.yesNo.No, Validators.required);

    this.sectionDForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionDForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionDForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionD(): void {
    if (this.sectionDForm.valid) {
      this.onSaveSection6.emit(this.sectionDForm.value);
    }
  }

}
